import { call, takeLatest, put } from 'redux-saga/effects';

import clearQuestionStorage from 'app/utils/clearQuestionStorage';
import { Actions as QuestionsGetAllActions } from 'app/redux/questions/get-all/actions';
import { Actions as QuestionsCategoryOptionsActions } from 'app/redux/questions/category-options/actions';
import { Actions as MediaGetAllActions } from 'app/redux/media/get-all/actions';
import { Types } from './actions';

const initialize = function*() {
  yield call(clearQuestionStorage);
  yield put(QuestionsGetAllActions.request());
  yield put(QuestionsCategoryOptionsActions.request());
  yield put(MediaGetAllActions.request());
};

const HomeSaga = function*() {
  yield takeLatest(Types.INITIALIZE, initialize);
};

export default HomeSaga;



// WEBPACK FOOTER //
// ./src/redux/ui/home/sagas.js